export default "__VITE_ASSET__fe99499c__"